import { render, staticRenderFns } from "./OtherFormsTable.vue?vue&type=template&id=20cdeece"
import script from "./OtherFormsTable.vue?vue&type=script&lang=ts"
export * from "./OtherFormsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports